import CmpCheckMultipleOptionList from "./CmpCheckMultipleOptionList";

export default CmpCheckMultipleOptionList;